<script lang="ts">
  import { Breadcrumb, BreadcrumbItem, Col} from 'sveltestrap';
  import { BreadcrumbMessage, Data, DefaultSveltestrapBreadcrumb, Home, Library } from '../../../utils/Constant/Constant';
  import Card from '../../Core/Card.svelte';
</script>
<Col sm="12">
    <Card headerTitle={DefaultSveltestrapBreadcrumb} cardHeaderprops="pb-0">
      <div slot="customheader">
        <span> {@html BreadcrumbMessage}</span>
      </div>
      <div slot="contentbody">
        <Breadcrumb >
            <BreadcrumbItem active>{Home}</BreadcrumbItem>
        </Breadcrumb>
        <Breadcrumb >
            <BreadcrumbItem>
              <a href="#Home">{Home}</a>
            </BreadcrumbItem>
            <BreadcrumbItem active>{Library}</BreadcrumbItem>
        </Breadcrumb>
        <Breadcrumb >
            <BreadcrumbItem>
              <a href="#Home">{Home}</a>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <a href="#Library">{Library}</a>
            </BreadcrumbItem>
            <BreadcrumbItem active>{Data}</BreadcrumbItem>
        </Breadcrumb>
        <Breadcrumb >
            <BreadcrumbItem>
              <a href="#icon">
                <i class="fa fa-home" />
              </a>
            </BreadcrumbItem>
            <BreadcrumbItem>{Library}</BreadcrumbItem>
            <BreadcrumbItem active>{Data}</BreadcrumbItem>
        </Breadcrumb>
      </div>
    </Card>
</Col>